import { getIpFingerprint } from '@/utils/fingerprint/ip'
import { getFbclid } from '@/apis/campaign'
import { Actions } from '@/constants/action'
import type { Action } from '@/typings/action'

// 通过url拿，应该只有一个action
export const getActionByUrl = async () => {
  // 解析URL中的action参数并base64解码
  const urlParams = new URLSearchParams(window.location.search)
  const action = urlParams.get('action')
  if (action) {
    try {
      const decodedAction = atob(action)

      // 解析JSON数据
      const actionData = JSON.parse(decodedAction)
      console.log('actionData', actionData)

      // 检查localStorage中是否已存在该action
      if (
        !localStorage.getItem(`action-${actionData.action}-${actionData.data.key}`) &&
        !localStorage.getItem(`processedActions-${actionData.action}-${actionData.data.key}`)
      ) {
        // 存储到localStorage
        localStorage.setItem(`action-${actionData.action}-${actionData.data.key}`, JSON.stringify(actionData))

        // 记录已处理过的action，防止重复处理
        if (hasProcessedAction(decodedAction)) {
          // 如果有过期时间，设置定时器在到期时自动清除
          if (actionData.expire_time) {
            const now = Date.now()
            const expireTime = actionData.expire_time
            const timeLeft = expireTime - now

            if (timeLeft > 0) {
              setTimeout(() => {
                localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
              }, timeLeft)
            } else {
              console.info('Action already expired')
              localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
            }
          }
        } else {
          console.info('This action link has been processed before, removing from localStorage')
          localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
        }
      } else {
        console.info('Action already exists in localStorage, skipping')
      }
    } catch (error) {
      console.error('Failed to decode action parameter:', error)
    }
  }
}

export const getClidByIpAction = async () => {
  // 通过ip拿，可能有多个
  const ipInfo = await getIpFingerprint()
  if (!ipInfo || !ipInfo.ipAddress) return []
  const promiseList: { fbclid: string }[] = []
  for (const actionKey of Object.keys(Actions)) {
    const actionValue = Actions[actionKey as keyof typeof Actions]
    const res = await getFbclid(`${ipInfo.ipAddress}-${actionValue}`)
    if (res.fbclid !== '') {
      promiseList.push(res)
    }
  }

  // 从cookie中拿, 可能存在多个
  for (const actionKey of Object.keys(Actions)) {
    const actionValue = Actions[actionKey as keyof typeof Actions]
    const actionCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`action-${actionValue}=`))
    if (actionCookie) {
      // 解析JSON数据
      try {
        const actionData = JSON.parse(atob(actionCookie.split('=')[1]))
        localStorage.setItem(`action-${actionValue}-${actionData.data.key}`, JSON.stringify(actionData))
      } catch (error) {
        console.error('Failed to decode action cookie:', error)
      }
    }
  }

  if (promiseList.length > 0) {
    const responses = await Promise.all(promiseList)
    if (responses) {
      try {
        for (const response of responses) {
          const actionValue = response.fbclid
          try {
            const decodedAction = atob(actionValue)
            // 解析JSON数据

            const actionData = JSON.parse(decodedAction)

            // 检查localStorage中是否已存在该action
            if (
              !localStorage.getItem(`action-${actionData.action}-${actionData.data.key}`) &&
              !localStorage.getItem(`processedActions-${actionData.action}-${actionData.data.key}`)
            ) {
              // 存储到localStorage，使用 JSON.stringify 格式化
              localStorage.setItem(`action-${actionData.action}-${actionData.data.key}`, JSON.stringify(actionData))

              // 记录已处理过的action，防止重复处理
              if (hasProcessedAction(decodedAction)) {
                // 如果有过期时间，设置定时器在到期时自动清除
                if (actionData.expire_time) {
                  const now = Date.now()
                  const expireTime = actionData.expire_time
                  const timeLeft = expireTime - now

                  if (timeLeft > 0) {
                    setTimeout(() => {
                      localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
                    }, timeLeft)
                  } else {
                    console.info('Action already expired')
                    localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
                  }
                }
              } else {
                console.info('This action link has been processed before, removing from localStorage')
                localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
              }
            } else {
              console.info('Action already exists in localStorage, skipping')
            }
          } catch (error) {
            console.error('Failed to decode action value:', error)
            continue
          }
        }
      } catch (error) {
        console.error('Failed to decode action parameter:', error)
      }
    }
  }
}

export const getActionByFingerprint = async (deviceFingerprint: string) => {
  // 通过指纹拿，可能有多个
  const promiseList: { fbclid: string }[] = []
  for (const actionKey of Object.keys(Actions)) {
    const actionValue = Actions[actionKey as keyof typeof Actions]
    const res = await getFbclid(`${deviceFingerprint}-${actionValue}`)
    if (res.fbclid !== '') {
      promiseList.push(res)
    }
  }
  // 从cookie中拿, 可能存在多个
  for (const actionKey of Object.keys(Actions)) {
    const actionValue = Actions[actionKey as keyof typeof Actions]
    const actionCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`action-${actionValue}-${actionValue}=`))
    if (actionCookie) {
      try {
        // 解析JSON数据
        const cookieValue = actionCookie.split('=')[1]
        if (!cookieValue) continue

        try {
          const decodedAction = atob(cookieValue)
          const actionData = JSON.parse(decodedAction)
          if (actionData && typeof actionData === 'object') {
            localStorage.setItem(`action-${actionValue}-${actionData.data.key}`, JSON.stringify(actionData))
          }
        } catch (error) {
          console.error('Failed to decode cookie value:', error)
        }
      } catch (error) {
        console.error('Failed to parse cookie data:', error)
      }
    }
  }

  if (promiseList.length > 0) {
    try {
      const responses = await Promise.all(promiseList)

      for (const response of responses) {
        try {
          if (!response || !response.fbclid) {
            console.warn('Invalid response:', response)
            continue
          }

          const actionValue = response.fbclid

          try {
            const decodedAction = atob(actionValue)

            if (!decodedAction) {
              console.warn('Empty decoded action')
              continue
            }

            // 解析JSON数据
            const actionData = JSON.parse(decodedAction)

            if (!actionData || !actionData.action) {
              console.warn('Invalid action data:', actionData)
              continue
            }

            // 检查localStorage中是否已存在该action
            if (
              !localStorage.getItem(`action-${actionData.action}-${actionData.data.key}`) &&
              !localStorage.getItem(`processedActions-${actionData.action}-${actionData.data.key}`)
            ) {
              // 存储到localStorage
              localStorage.setItem(`action-${actionData.action}-${actionData.data.key}`, JSON.stringify(actionData))

              // 记录已处理过的action，防止重复处理
              try {
                if (hasProcessedAction(decodedAction)) {
                  // 如果有过期时间，设置定时器在到期时自动清除
                  if (actionData.expire_time) {
                    const now = Date.now()
                    const expireTime = actionData.expire_time
                    const timeLeft = expireTime - now

                    if (timeLeft > 0) {
                      setTimeout(() => {
                        localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
                      }, timeLeft)
                    } else {
                      console.info('Action already expired')
                      localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
                    }
                  }
                } else {
                  console.info(
                    'This action link has been processed before, removing from localStorage'
                  )
                  localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
                }
              } catch (error) {
                console.error('Failed to process action:', error)
              }
            } else {
              console.info('Action already exists in localStorage, skipping')
            }
          } catch (error) {
            console.error('Failed to decode fbclid:', error)
            continue
          }
        } catch (error) {
          console.error('Failed to process response:', error)
        }
      }
    } catch (error) {
      console.error('Failed to process promises:', error)
    }
  }
}

export const getActionByUserId = async (userId: string) => {
  // 通过用户id拿，可能有多个
  const promiseList: { fbclid: string }[] = []
  for (const actionKey of Object.keys(Actions)) {
    const actionValue = Actions[actionKey as keyof typeof Actions]
    const res = await getFbclid(`${userId}-${actionValue}`)
    if (res.fbclid !== '') {
      promiseList.push(res)
    }
  }

  if (promiseList.length > 0) {
    try {
      const responses = await Promise.all(promiseList)

      for (const response of responses) {
        try {
          if (!response || !response.fbclid) {
            console.warn('Invalid response:', response)
            continue
          }

          const actionValue = response.fbclid

          try {
            const decodedAction = atob(actionValue)

            if (!decodedAction) {
              console.warn('Empty decoded action')
              continue
            }

            // 解析JSON数据
            const actionData = JSON.parse(decodedAction)

            if (!actionData || !actionData.action) {
              console.warn('Invalid action data:', actionData)
              continue
            }

            // 检查localStorage中是否已存在该action
            if (
              !localStorage.getItem(`action-${actionData.action}-${actionData.data.key}`) &&
              !localStorage.getItem(`processedActions-${actionData.action}-${actionData.data.key}`)
            ) {
              // 存储到localStorage
              localStorage.setItem(`action-${actionData.action}-${actionData.data.key}`, JSON.stringify(actionData))

              // 记录已处理过的action，防止重复处理
              try {
                if (hasProcessedAction(decodedAction)) {
                  // 如果有过期时间，设置定时器在到期时自动清除
                  if (actionData.expire_time) {
                    const now = Date.now()
                    const expireTime = actionData.expire_time
                    const timeLeft = expireTime - now

                    if (timeLeft > 0) {
                      setTimeout(() => {
                        localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
                      }, timeLeft)
                    } else {
                      console.info('Action already expired')
                      localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
                    }
                  }
                } else {
                  console.info(
                    'This action link has been processed before, removing from localStorage'
                  )
                  localStorage.removeItem(`action-${actionData.action}-${actionData.data.key}`)
                }
              } catch (error) {
                console.error('Failed to process action:', error)
              }
            } else {
              console.info('Action already exists in localStorage, skipping')
            }
          } catch (error) {
            console.error('Failed to decode action value:', error)
            continue
          }
        } catch (error) {
          console.error('Failed to process response:', error)
        }
      }
    } catch (error) {
      console.error('Failed to process promises:', error)
    }
  }
}

export const hasProcessedAction = (decodedAction: string) => {
  const actionData = JSON.parse(decodedAction)
  const processedActions = JSON.parse(
    localStorage.getItem(`processedActions-${actionData.action}-${actionData.data.key}`) || '[]'
  )
  if (!processedActions.includes(actionData)) {
    return true
  }
  return false
}

export const setProcessedAction = (actionData: Action) => {
  const processedActions = JSON.parse(
    localStorage.getItem(`processedActions-${actionData.action}-${actionData.data.key}`) || '[]'
  )
  if (!processedActions.includes(actionData.action)) {
    processedActions.push(actionData.action + '-' + actionData.data.key)
    localStorage.setItem(`processedActions-${actionData.action}-${actionData.data.key}`, JSON.stringify(processedActions))
  }
}

export const hasAction = (key: string) => {
  // 查找包含该key的所有action
  const allKeys = Object.keys(localStorage)
  const actionKeys = allKeys.filter(k => k.startsWith(`action-${key}-`))
  
  if (actionKeys.length === 0) {
    return false
  }
  
  // 检查是否有有效的action数据
  for (const actionKey of actionKeys) {
    const actionData = JSON.parse(localStorage.getItem(actionKey) || '{}')
    if (actionData && actionData.action) {
      // 检查是否过期
      if (actionData.expire_time) {
        const now = Date.now()
        if (now <= actionData.expire_time) {
          return true
        } else {
          // 过期了，删除
          localStorage.removeItem(actionKey)
        }
      } else {
        return true
      }
    }
  }
  
  return false
}

export const removeAction = (key: string) => {
  // 删除所有包含该key的action
  const allKeys = Object.keys(localStorage)
  const actionKeys = allKeys.filter(k => k.startsWith(`action-${key}-`))
  
  actionKeys.forEach(actionKey => {
    localStorage.removeItem(actionKey)
  })
}
